module.exports = __webpack_public_path__ + "assets/img/revisorLogo.3014eac0.png";